import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../ThemeContext';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import '../../../common-ui.css';
import './Form360.css';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Breadcrumb from '../../Layouts/Breadcrumb';
import CardContent from '@material-ui/core/CardContent';
import { Card, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress } from '@material-ui/core';
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import ls from 'local-storage';
import { Dialog, DialogTitle, DialogContent, TablePagination } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AuthCheckComponent from '../../Layouts/Token';
import { IconButton, Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import CommonTablePaginationActions, {
  COMMON_PAGINATION_CLASS,
  commonPaginationSelectProps,
  getCommonPaginationStyle,
} from '../../Common/commonPagination';

// Exact same StyledTableRow as TableComponent
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5',
    },
    '&.dark-theme &:nth-of-type(odd), .dark-theme &:nth-of-type(odd)': {
      backgroundColor: '#2a2a2a !important',
    },
    '&:hover': {
      backgroundColor: '#c2cddf !important',
    },
    '&.dark-theme &:hover, .dark-theme &:hover': {
      backgroundColor: '#2b3744 !important',
    },
  },
}))(TableRow);

// Exact same useStyles as TableComponent
const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  head: {
    backgroundColor: '#036dda',
    color: '#fff',
    margin: '0 auto',
    '& th': { color: '#fff' },
    '& th > span:hover': { color: '#fff' },
    '& th:hover': { color: '#fff' },
    '& th:active': { color: '#fff' },
    '& th > span:active': { color: '#fff' },
  },
});

export default function Form360(props) {
  const navigationButtonStyle = {
    textTransform: 'capitalize',
  };

  const previousButtonStyle = {
    ...navigationButtonStyle,
  };

  const renderRequiredLabel = (label) => (
    <>
      {label} <span className="required-asterisk">*</span>
    </>
  );

  const getSelectedValues = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value.trim() !== "") {
      return value.split(",").map((item) => item.trim()).filter(Boolean);
    }
    return [];
  };

  const getQuestionLabel = (item = {}) =>
    item.label ||
    item.input_label ||
    item.content_label ||
    item.field_label ||
    item.question_label ||
    item.input_name ||
    item.field_name ||
    item.name ||
    item.lable ||
    "";
  const getQuestionTitle = (item = {}) => item.title || item.form_title || item.section_title || "";
  const normalizeOptions = (options) => (Array.isArray(options) ? options : []);
  const normalizeFormDetail = (item = {}) => ({
    ...item,
    label: getQuestionLabel(item),
    type: item.type || "text",
    options: normalizeOptions(item.options),
  });
  const normalizeFormContent = (item = {}) => ({
    ...item,
    title: getQuestionTitle(item),
    label: getQuestionLabel(item),
    type: item.type || "text",
    options: normalizeOptions(item.options),
  });
  const classes = useStyles();

  // if you don't have ThemeContext, you can remove useTheme usage below
  let darkMode = false;
  try {
    const theme = useTheme();
    darkMode = theme?.darkMode || false;
  } catch (e) {
    // ignore if useTheme not provided
    darkMode = false;
  }

  const User = ls("user");
  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentSection, setCurrentSection] = useState(-1);
  const [responses, setResponses] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [data, setData] = useState(null);
  const [reviewformlist, setReviewformlist] = useState([]);
  const [reviewformlistdata, setReviewformlistdata] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [viewMode, setViewMode] = useState(userpermissions.includes("Form360.List") ? 'list' : '');
  const [errors, setErrors] = useState({});
  const [totalSelections, setTotalSelections] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedBulkAction, setSelectedBulkAction] = useState('');
  const [isListLoading, setIsListLoading] = useState(true);

  useEffect(() => {
    Reviewformlisttitle();
    Reviewformdynamiclistid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -----------------------
  // API / Data functions
  // -----------------------
  const Reviewformlisttitle = async () => {
    try {
      let res = await Authapi.Reviewformlist();
      if (res && res.data) setReviewformlist(res.data);
    } catch (error) {
      console.error('Error fetching Reviewformlist:', error);
    }
  };

  const Reviewformdynamiclistid = async () => {
    setIsListLoading(true);
    try {
      const user = ls('user') || {};
      const userid = user.id;
      const role = ls('roles') || ls('role') || null; // attempt both keys
      // If your Authapi exposes different functions, prefer one that exists
      if (role === "Super Admin" && Authapi.Reviewformdynamiclist) {
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      } else if (Authapi.Reviewformdynamiclistid) {
        const resp = await Authapi.Reviewformdynamiclistid(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      } else if (Authapi.Reviewformdynamiclist) {
        // fallback if only Reviewformdynamiclist exists
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      }
    } catch (error) {
      console.error('Error fetching Reviewformdynamiclistid:', error);
      setReviewformlistdata([]);
      setSelectedRows([]);
    } finally {
      setIsListLoading(false);
    }
  };

  const fetchFormDetailsById = async (formId) => {
    try {
      const role = await Authapi.ReviewformlistgetformbyID(formId);
      if (role && role.data) {
        setData({
          ...role.data,
          form_details: (role.data.form_details || []).map(normalizeFormDetail),
          form_content: (role.data.form_content || []).map(normalizeFormContent),
        });
        // reset section to beginning for new form
        setCurrentSection(-1);
        setErrors({});
        setFormDetails({});
        setResponses({});
      }
    } catch (error) {
      console.error('Error fetching form details:', error);
    }
  };

  // -----------------------
  // Handlers
  // -----------------------
  const handleDetailChange = (label, value, type = 'text') => {
    setFormDetails((prev) => {
      if (type === 'checkbox') {
        const existingSelections = getSelectedValues(prev[label]);
        const updatedSelections = existingSelections.includes(value)
          ? existingSelections.filter((item) => item !== value)
          : [...existingSelections, value];

        return {
          ...prev,
          [label]: updatedSelections,
        };
      }

      return { ...prev, [label]: value };
    });
  };

  const handleResponseChange = (sectionIndex, questionIndex, value, label, type) => {
    setResponses((prevResponses) => {
      const currentSectionResponses = prevResponses[sectionIndex] || {};
      const currentQuestionResponses = currentSectionResponses[label] || "";

      let updatedQuestionResponses;
      if (type === 'checkbox') {
        const selectedOptions = getSelectedValues(currentQuestionResponses);
        if (selectedOptions.includes(value)) {
          updatedQuestionResponses = selectedOptions.filter(item => item !== value);
        } else {
          updatedQuestionResponses = [...selectedOptions, value];
        }
      } else {
        updatedQuestionResponses = value;
      }

      // Update totalSelections for radio type (optional)
      if (type === 'radio') {
        // recompute totalSelections
        const newResponses = {
          ...prevResponses,
          [sectionIndex]: {
            ...currentSectionResponses,
            [label]: updatedQuestionResponses
          }
        };
        let count = 0;
        Object.values(newResponses).forEach(section => {
          Object.values(section || {}).forEach(v => {
            if (v && v.toString().trim() !== '') count++;
          });
        });
        setTotalSelections(count);
      }

      return {
        ...prevResponses,
        [sectionIndex]: {
          ...currentSectionResponses,
          [label]: updatedQuestionResponses
        }
      };
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (currentSection === -1 && data?.form_details) {
      data.form_details.forEach(detail => {
        const detailLabel = getQuestionLabel(detail);
        if (detail.type === 'checkbox') {
          const selectedOptions = getSelectedValues(formDetails[detailLabel]);
          if (!selectedOptions || selectedOptions.length === 0) {
            newErrors[detailLabel] = `${detailLabel} is required`;
          }
        } else if (!formDetails[detailLabel] || formDetails[detailLabel].toString().trim() === '') {
          newErrors[detailLabel] = `${detailLabel} is required`;
        }
      });
    } else if (data && data.form_content) {
      const uniqueTitles = Array.from(new Set(data.form_content.map(content => getQuestionTitle(content))));
      const currentTitle = uniqueTitles[currentSection];
      if (currentTitle) {
        data.form_content
          .filter(content => getQuestionTitle(content) === currentTitle)
          .forEach(question => {
            const questionLabel = getQuestionLabel(question);
            const response = responses[currentSection]?.[questionLabel];
            if (question.type === 'checkbox') {
              const selectedOptions = getSelectedValues(response);
              if (!selectedOptions || selectedOptions.length === 0) {
                newErrors[questionLabel] = `${questionLabel} is required`;
              }
            } else if (!response || response.toString().trim() === '') {
              newErrors[questionLabel] = `${questionLabel} is required`;
            }
          });
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      setViewMode("list");
    } else {
      console.log("Validation failed", errors);
    }
  };

  const createLeaves = async () => {
    const serializeCheckboxValues = (source = {}) =>
      Object.entries(source).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: Array.isArray(value) ? value.join(', ') : value
      }), {});

    const finalPostData = {
      ...serializeCheckboxValues(formDetails),
      ...Object.values(responses).reduce(
        (acc, section) => ({ ...acc, ...serializeCheckboxValues(section) }),
        {}
      )
    };

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    try {
      const create = await Authapi.Reviewformdynamicadd(finalPostData, data?.form_name);
      swal.close();
      if (create && create.status === true) {
        setViewMode("list");
        Reviewformdynamiclistid();
        swal("Success", "Form submitted successfully!", "success");
      } else {
        swal("OOPS!", "Something went wrong, please try later!", "error");
      }
    } catch (error) {
      swal.close();
      console.error("Error creating record:", error);
      swal("Error", "Server error while submitting form", "error");
    }
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    if (currentSection === -1) {
      setCurrentSection(0);
    } else if (data && data.form_content) {
      const uniqueTitles = [...new Set(data.form_content.map(item => getQuestionTitle(item)))];
      if (currentSection < uniqueTitles.length - 1) {
        setCurrentSection(prev => prev + 1);
      } else if (currentSection === uniqueTitles.length - 1) {
        // last section -> create
        await createLeaves();
      }
    }
  };

  const handlePrevious = () => {
    if (currentSection > 0) setCurrentSection(prev => prev - 1);
    else if (currentSection === 0) setCurrentSection(-1);
  };

  const handleFormSelect = (event) => {
    const formId = event.target.value;
    setSelectedFormId(formId);
    fetchFormDetailsById(formId);
  };

  const handleViewClick = (row) => {
    setSelectedData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedData(null);
  };

  const handleViewModeChange = (event) => {
    setViewMode(event.target.value);
    if (event.target.value === "addForm") {
      setIsSubmitted(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormDetails({});
    setResponses({});
    setCurrentSection(-1);
    setErrors({});
    setData(null);
    setSelectedFormId(null);
  };

  const handleDeleteClick = async (formId) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const resp = await Authapi.Reviewformdynamicdelete(formId);
          if (resp && resp.status === true) {
            Reviewformdynamiclistid();
            swal("Success", "Form deleted successfully!", "success");
          } else {
            swal("Error", "Unable to delete", "error");
          }
        } catch (err) {
          console.error("Error deleting:", err);
          swal("Error", "Server error while deleting", "error");
        }
      }
    });
  };

  const paginatedRows = (reviewformlistdata || []).slice(page * pageSize, page * pageSize + pageSize);
  const isAllCurrentPageSelected = paginatedRows.length > 0 && paginatedRows.every((row) => selectedRows.includes(row.id));
  const isPartialCurrentPageSelected = paginatedRows.some((row) => selectedRows.includes(row.id)) && !isAllCurrentPageSelected;

  const handleSelectAllCurrentPage = (event) => {
    if (event.target.checked) {
      const currentPageIds = paginatedRows.map((row) => row.id);
      setSelectedRows((prevSelected) => Array.from(new Set([...prevSelected, ...currentPageIds])));
      return;
    }

    const currentPageIds = paginatedRows.map((row) => row.id);
    setSelectedRows((prevSelected) => prevSelected.filter((id) => !currentPageIds.includes(id)));
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: `Selected ${selectedRows.length} form(s) will be deleted.`,
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (!confirm) {
        return;
      }

      try {
        const results = await Promise.allSettled(
          selectedRows.map((formId) => Authapi.Reviewformdynamicdelete(formId))
        );
        const successCount = results.filter(
          (result) => result.status === "fulfilled" && result.value?.status === true
        ).length;

        if (successCount === selectedRows.length) {
          swal("Success", "Selected forms deleted successfully!", "success");
        } else if (successCount > 0) {
          swal("Partial Success", `${successCount} form(s) deleted successfully.`, "warning");
        } else {
          swal("Error", "Unable to delete selected forms", "error");
        }

        Reviewformdynamiclistid();
      } catch (error) {
        console.error("Error bulk deleting forms:", error);
        swal("Error", "Server error while deleting selected forms", "error");
      }
    });
  };

  const handleBulkActionSubmit = () => {
    if (selectedBulkAction === 'delete') {
      handleBulkDelete();
    }
  };

  // -----------------------
  // DataGrid columns
  // -----------------------






  return (
    <div className="form360-container">
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        setAutUser={props.setAutUser}
        component={
          <>
            <Card className={classes.card}>
              <CardContent>
                <Breadcrumb {...props}
                  primaryPageName="Feedback Forms"
                  primaryPageLink="/dashboard"
                  isSecondaryPage={false}
                  secondaryPageName="" />
              </CardContent>
            </Card>

            <FormControl variant="outlined" className="form-control" style={{ width: "82%", marginTop: '20px' }}>
              <InputLabel>Choose Action</InputLabel>
              <Select
                onChange={handleViewModeChange}
                value={viewMode || ''}
                className="styled-select"
                label="Choose Action"
              >
                <MenuItem value="" disabled>Select an action</MenuItem>
                <MenuItem value="addForm">Add Form</MenuItem>
                {userpermissions.includes("Form360.List") && <MenuItem value="list">List</MenuItem>}
              </Select>
            </FormControl>

            {viewMode === 'addForm' && (
              <div style={{ marginTop: '62px' }}>
                <FormControl variant="outlined" className="form-control" style={{ width: "82%" }}>
                  <InputLabel>Select a form</InputLabel>
                  <Select
                    onChange={handleFormSelect}
                    value={selectedFormId || ''}
                    className="styled-select"
                    label="Select a form"
                  >
                    <MenuItem value="" disabled>Select a form</MenuItem>
                    {reviewformlist && reviewformlist.map((form) => (
                      <MenuItem key={form.id} value={form.id}>
                        {form.form_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {data && (
                  <div className="form-container" style={{ marginBottom: '80px', marginTop: "45px" }}>
                    <form onSubmit={handleSubmit}>
                      <Typography variant="h4" style={{ color: '#036dda', marginBottom: '20px' }}>
                        {data?.form_name}
                      </Typography>

                      {currentSection === -1 && data?.form_details && (
                        <div className={darkMode ? "dark-background" : ""}>
                          <div className="form-row">
                            {data.form_details.map((detail, index) => (
                              <div className="form-group" key={index}>
                                <label
                                  className="required-field-label"
                                  style={{ color: darkMode ? '#ffffff' : '#000000' }}
                                >
                                  {renderRequiredLabel(getQuestionLabel(detail))}
                                </label>

                                {detail.type === 'radio' ? (
                                  <RadioGroup
                                    name={getQuestionLabel(detail)}
                                    value={formDetails[getQuestionLabel(detail)] || ""}
                                    onChange={(e) => handleDetailChange(getQuestionLabel(detail), e.target.value, 'radio')}
                                    className="form-input"
                                    style={{ display: "ruby" }}
                                  >
                                    {detail.options && detail.options.map((option, idx) => (
                                      <FormControlLabel
                                        key={idx}
                                        value={option}
                                        control={<Radio />}
                                        label={option}
                                      />
                                    ))}
                                  </RadioGroup>
                                ) : detail.type === 'checkbox' ? (
                                  <div className="checkbox-group">
                                    {detail.options && detail.options.map((option, idx) => (
                                      <FormControlLabel
                                        key={idx}
                                        style={{ display: "ruby" }}
                                        control={
                                          <Checkbox
                                            checked={getSelectedValues(formDetails[getQuestionLabel(detail)]).includes(option)}
                                            onChange={() => handleDetailChange(getQuestionLabel(detail), option, 'checkbox')}
                                          />
                                        }
                                        label={option}
                                      />
                                    ))}
                                  </div>
                                ) : detail.type === 'textarea' ? (
                                  <textarea
                                    name={getQuestionLabel(detail)}
                                    required
                                    value={formDetails[getQuestionLabel(detail)] || ""}
                                    onChange={(e) => handleDetailChange(getQuestionLabel(detail), e.target.value, detail.type)}
                                    className="form-input"
                                    rows={4}
                                  />
                                ) : (
                                  <input
                                    type={detail.type}
                                    name={getQuestionLabel(detail)}
                                    required
                                    value={formDetails[getQuestionLabel(detail)] || ""}
                                    onChange={(e) => handleDetailChange(getQuestionLabel(detail), e.target.value, detail.type)}
                                    className="form-input"
                                  />
                                )}

                                {errors[getQuestionLabel(detail)] && (
                                  <span className="field-error">{errors[getQuestionLabel(detail)]}</span>
                                )}
                              </div>
                            ))}
                          </div>
                          <div className="form-group form-actions-right">
                            <Button
                              variant="contained"
                              color="primary"
                              className="common-step-navigation-button"
                              onClick={handleNext}
                              style={navigationButtonStyle}
                            >
                              Next
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Feedback Sections */}
                      {currentSection >= 0 &&
                        data?.form_content &&
                        currentSection < Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).length && (
                          <>
                            <div className="progress-indicator">
                              {Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).map((title, index) => (
                                <div
                                  key={index}
                                  className={`progress-step ${index === currentSection ? 'active' : ''}`}
                                  onClick={() => setCurrentSection(index)}
                                >
                                  <span className="step-number">{index + 1}</span>
                                  <span className="step-title">{title}</span>
                                </div>
                              ))}
                            </div>


                            <div className={`form-section ${darkMode ? "dark-background" : ""}`}>

                              <Typography
                                variant="h5"
                                style={{
                                  color: darkMode ? '#ffffff' : '#036dda',
                                  marginBottom: '10px'
                                }}
                              >
                                {Array.from(new Set(data.form_content.map(content => getQuestionTitle(content))))[currentSection]}
                              </Typography>

                              <table className="table">
                                <tbody>
                                  {data.form_content
                                    .filter(
                                      content =>
                                        getQuestionTitle(content) ===
                                        Array.from(new Set(data.form_content.map(content => getQuestionTitle(content))))[currentSection]
                                    )
                                    .map((question, index) => (
                                      <div className="form-group question-group" key={index}>
                                          <Typography
                                            variant="h6"
                                            className="required-field-label"
                                            style={{
                                              textAlign: "justify",
                                              marginBottom: '8px',
                                              color: darkMode ? "#ffffff" : "#000000"
                                            }}
                                          >
                                            {renderRequiredLabel(getQuestionLabel(question))}
                                          </Typography>

                                          {question.type === 'checkbox' ? (
                                            question.options &&
                                            question.options.map((option, idx) => (
                                              <FormControlLabel
                                                key={idx}
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      getSelectedValues(
                                                        responses[currentSection]?.[getQuestionLabel(question)]
                                                      ).includes(option)
                                                    }
                                                    onChange={(e) =>
                                                      handleResponseChange(currentSection, index, option, getQuestionLabel(question), 'checkbox')
                                                    }
                                                  />
                                                }
                                                label={option}
                                                style={{ marginRight: '16px', color: darkMode ? "#ffffff" : "#000000" }}
                                              />
                                            ))
                                          ) : question.type === 'radio' ? (
                                            <RadioGroup
                                              row
                                              name={`question-${currentSection}-${index}`}
                                              value={responses[currentSection]?.[getQuestionLabel(question)] || ""}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, getQuestionLabel(question), 'radio')
                                              }
                                            >
                                              {question.options &&
                                                question.options.map((option, idx) => (
                                                  <FormControlLabel
                                                    key={idx}
                                                    value={option ? option.toString() : ""}
                                                    control={<Radio />}
                                                    label={option}
                                                    style={{ marginRight: '16px', color: darkMode ? "#ffffff" : "#000000" }}
                                                  />
                                                ))}
                                            </RadioGroup>
                                          ) : question.type === 'textarea' ? (
                                            <textarea
                                              name={getQuestionLabel(question)}
                                              value={responses[currentSection]?.[getQuestionLabel(question)] || ""}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, getQuestionLabel(question), question.type)
                                              }
                                              className="form-input"
                                              rows={4}
                                              style={{
                                                width: '100%',
                                                padding: '10px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                boxSizing: 'border-box',
                                                background: darkMode ? "#2c2c2c" : "#ffffff",
                                                color: darkMode ? "#ffffff" : "#000000"
                                              }}
                                            />
                                          ) : (
                                            <input
                                              type={question.type}
                                              name={getQuestionLabel(question)}
                                              value={responses[currentSection]?.[getQuestionLabel(question)] || ""}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, getQuestionLabel(question), question.type)
                                              }
                                              className="form-input"
                                              style={{
                                                width: '100%',
                                                padding: '10px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                boxSizing: 'border-box',
                                                background: darkMode ? "#2c2c2c" : "#ffffff",
                                                color: darkMode ? "#ffffff" : "#000000"
                                              }}
                                            />
                                          )}

                                        {errors[getQuestionLabel(question)] && (
                                          <span className="field-error">
                                            {errors[getQuestionLabel(question)]}
                                          </span>
                                        )}
                                      </div>
                                    ))}
                                </tbody>
                              </table>

                              <div className="form-navigation">
                                {currentSection >= 0 && (
                                  <Button
                                    variant="contained"
                                    className="common-step-navigation-button"
                                    onClick={handlePrevious}
                                    style={previousButtonStyle}
                                  >
                                    Previous
                                  </Button>
                                )}
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className="common-step-navigation-button"
                                  onClick={handleNext}
                                  style={navigationButtonStyle}
                                >
                                  {currentSection === Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).length - 1 ? 'Submit' : 'Next'}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                      {/* Thank You Section */}
                      {data && currentSection === Array.from(new Set(data.form_content ? data.form_content.map(content => getQuestionTitle(content)) : [])).length && (
                        <div>
                          <Typography variant="h4" style={{ color: '#4caf50' }}>
                            Thank you for your submission!
                          </Typography>
                        </div>
                      )}
                    </form>
                  </div>
                )}
              </div>
            )}

            {viewMode === 'list' && (
              <div style={{ marginBottom: '80px', marginTop: '62px' }}>
                <Paper style={{ width: '98%', margin: '0 auto', overflow: 'hidden' }}>
                  <TableContainer style={{ maxHeight: '100%', overflowX: 'auto' }}>
                    <Table className={classes.table} aria-label="form 360 list" style={{ tableLayout: 'auto', minWidth: '100%' }}>
                      <TableHead>
                        <TableRow className={classes.head}>
                          <TableCell padding="checkbox" style={{ color: '#fff', fontWeight: 600 }}>
                            {paginatedRows.length > 0 && (
                              <div className="wrap-check-20">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={isAllCurrentPageSelected}
                                    ref={(input) => {
                                      if (input) {
                                        input.indeterminate = isPartialCurrentPageSelected;
                                      }
                                    }}
                                    onChange={handleSelectAllCurrentPage}
                                  />
                                  <span className="checkbox"></span>
                                </label>
                              </div>
                            )}
                          </TableCell>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>Form Title</TableCell>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>User Name</TableCell>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isListLoading ? (
                          <StyledTableRow>
                            <TableCell colSpan={4} align="center" style={{ backgroundColor: darkMode ? '#1e1e1e' : 'inherit', padding: '24px' }}>
                              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CircularProgress size={22} thickness={5} color="primary" />
                              </div>
                            </TableCell>
                          </StyledTableRow>
                        ) : (reviewformlistdata || []).length === 0 ? (
                          <StyledTableRow>
                            <TableCell colSpan={4} align="center" style={{ fontWeight: 'bold', color: darkMode ? '#fff' : 'inherit', backgroundColor: darkMode ? '#1e1e1e' : 'inherit' }}>
                              No rows found
                            </TableCell>
                          </StyledTableRow>
                        ) : (
                          paginatedRows
                            .map((row) => (
                              <StyledTableRow key={row.id}>
                                <TableCell padding="checkbox">
                                  <div className="wrap-check-20">
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={selectedRows.includes(row.id)}
                                        onChange={() => handleSelectRow(row.id)}
                                      />
                                      <span className="checkbox"></span>
                                    </label>
                                  </div>
                                </TableCell>
                                <TableCell align="left">{row.form_name}</TableCell>
                                <TableCell align="left">{row.first_name}</TableCell>
                                <TableCell align="left">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Tooltip title="View">
                                      <IconButton size="small" color="primary" className="common-action-icon" onClick={() => handleViewClick(row)}>
                                        <FontAwesomeIconComponent
                                          classes="fa fa-eye"
                                          colorName="primary"
                                          fontSize={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                      <IconButton size="small" color="primary" className="common-action-icon" onClick={() => handleDeleteClick(row.id)}>
                                        <FontAwesomeIconComponent
                                          classes="fa fa-trash"
                                          colorName="primary"
                                          fontSize={"small"}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                </TableCell>
                              </StyledTableRow>
                            ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <div className="form360-list-footer">
                  <div className="form360-bulk-actions">
                    <Select
                      value={selectedBulkAction}
                      onChange={(event) => setSelectedBulkAction(event.target.value)}
                      displayEmpty
                      style={{ minWidth: '140px' }}
                    >
                      <MenuItem value="" disabled>Bulk Action</MenuItem>
                      <MenuItem value="delete">Delete</MenuItem>
                    </Select>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleBulkActionSubmit}
                      disabled={!selectedBulkAction || selectedRows.length === 0}
                    >
                      Go
                    </Button>
                  </div>
                  <div className="form360-pagination-wrap">
                    <TablePagination
                      component="div"
                      count={(reviewformlistdata || []).length}
                      page={page}
                      onPageChange={(event, newPage) => setPage(newPage)}
                      rowsPerPage={pageSize}
                      SelectProps={commonPaginationSelectProps}
                      onRowsPerPageChange={(event) => {
                        setPageSize(parseInt(event.target.value, 10));
                        setPage(0);
                      }}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      className={COMMON_PAGINATION_CLASS}
                      style={getCommonPaginationStyle(darkMode)}
                      ActionsComponent={CommonTablePaginationActions}
                    />
                  </div>
                </div>

                <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm">
                  <DialogTitle
                    style={{
                      textAlign: "center",
                      padding: "5px 0",
                      backgroundColor: "#036dda",
                      color: "#fff",
                      position: "relative"
                    }}
                  >
                    Form Details
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                      onClick={handleCloseDialog}
                    />
                  </DialogTitle>
                  <DialogContent style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {selectedData && (
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '10px' }}>
                          <div>
                            <strong>Form Name:</strong> {selectedData.form_name}
                          </div>
                          <div>
                            <strong>User ID:</strong> {selectedData.user_id}
                          </div>
                        </div>
                        {selectedData.data && (
                          <div>
                            {Object.entries(selectedData.data).map(([sectionTitle, sectionData]) => (
                              <div key={sectionTitle} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                                <h5 style={{ marginBottom: '10px' }}>{sectionTitle.replace(/_/g, ' ')}</h5>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                  {Object.entries(sectionData).map(([key, value]) => (
                                    <div key={key} style={{ marginBottom: '10px', marginRight: '10px', flex: '1 1 45%' }}>
                                      <strong>{key.replace(/_/g, ' ')}:</strong>
                                      {Array.isArray(value) ? (
                                        value.map((option, idx) => (
                                          <FormControlLabel
                                            key={idx}
                                            control={<Checkbox checked={true} disabled />}
                                            label={option}
                                          />
                                        ))
                                      ) : typeof value === 'boolean' ? (
                                        <FormControlLabel
                                          control={<Checkbox checked={value} disabled />}
                                          label={key.replace(/_/g, ' ')}
                                        />
                                      ) : (
                                        <input
                                          type={typeof value === 'number' ? 'number' : 'text'}
                                          value={typeof value === 'object' ? JSON.stringify(value) : value}
                                          disabled
                                          style={{
                                            width: '100%',
                                            padding: '6px',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            marginTop: '5px'
                                          }}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </DialogContent>
                </Dialog>
              </div>
            )}
          </>
        }
      />
      <Footer {...props} />
    </div>
  );
}
